import type {
  BankAccount,
  BusinessInfo,
  CardTerminal,
  EWallet,
  PaymentConfig,
  SettingsFull,
} from '@/services/settings.service';

export const mockBusinessInfo: BusinessInfo = {
  name: 'TIỆM VÀNG KIM HOÀN',
  tax_code: '0123456789',
  address: '123 Lê Lợi, P.Bến Nghé, Q.1, TP.HCM',
  phone: '0281234567',
  email: 'contact@tiemvang.vn',
  logo: undefined,
  representative: 'Nguyễn Văn A',
  business_type: 'HKD',
  founded_year: '2010',
  website: 'https://tiemvang.vn',
};

export const mockPaymentConfig: PaymentConfig = {
  methods: ['cash', 'bank_transfer', 'vnpay'],
  default_method: 'cash',
  shifts: [
    { name: 'Ca sáng', start_time: '07:00', end_time: '14:00' },
    { name: 'Ca chiều', start_time: '14:00', end_time: '21:00' },
  ],
  require_shift_open: true,
};

export const mockBankAccounts: BankAccount[] = [
  {
    _id: 'mock-bank-1',
    tenant_id: 'mock-tenant',
    bank_name: 'Vietcombank',
    bank_code: '970436',
    account_number: '0123456789',
    account_name: 'TIỆM VÀNG KIM HOÀN',
    branch: 'CN TP.HCM',
    is_default: true,
  },
  {
    _id: 'mock-bank-2',
    tenant_id: 'mock-tenant',
    bank_name: 'BIDV',
    bank_code: '970418',
    account_number: '987654321',
    account_name: 'TIỆM VÀNG KIM HOÀN',
    is_default: false,
  },
];

export const mockEWallets: EWallet[] = [
  {
    _id: 'mock-wallet-1',
    tenant_id: 'mock-tenant',
    provider: 'Momo',
    account_number: '0901234567',
    account_name: 'TIỆM VÀNG KIM HOÀN',
    is_default: true,
  },
  {
    _id: 'mock-wallet-2',
    tenant_id: 'mock-tenant',
    provider: 'ZaloPay',
    account_number: '0907654321',
    account_name: 'TIỆM VÀNG KIM HOÀN',
    is_default: false,
  },
];

export const mockCardTerminals: CardTerminal[] = [
  {
    _id: 'mock-card-1',
    tenant_id: 'mock-tenant',
    acquirer: 'Vietcombank',
    terminal_id: 'TID000123',
    account_name: 'TIỆM VÀNG KIM HOÀN',
    is_default: true,
  },
];

export const mockSettingsFull: SettingsFull = {
  business: mockBusinessInfo,
  payment: mockPaymentConfig,
  einvoice: {
    enabled: false,
    provider: 'self',
    auto_issue: false,
    default_template: null,
  },
  notifications: {
    email: { enabled: false },
    zalo_zns: { enabled: false },
    sms: { enabled: false },
  },
  integrations: {
    ghtk: { enabled: false },
    napas: { enabled: false },
  },
  api_keys_enabled: false,
};
